// extracted by mini-css-extract-plugin
export var navContainer = "legal-module--navContainer--cgWZB";
export var navItem = "legal-module--navItem--QMe34";